import React, { FC } from "react";
import { Tabs } from "antd";
import styles from "./template-selection-form.module.css";

const { ["invitation-text"]: invitationTextClassName } = styles;

type Props = {
  searchType: string;
  children?: React.ReactNode;
};

export const TemplateSelectionForm: FC<Props> = ({ children, searchType }) => {
  return (
    <>
      <div className={invitationTextClassName}>Click option to select a {searchType}</div>
      <Tabs type="card">{children}</Tabs>
    </>
  );
};
